/* 4U product page: hidden colour photos load after the page is idle, or the
   moment a colour swatch is touched. Loaded once (cached) by
   snippets/media.liquid.

   Idle behaviour by device:
   - Desktop on a fast connection: every hidden photo is fetched in the background.
   - Phones (under 750px) or slower connections: only the FIRST photo of each
     hidden colour is fetched, so a colour switch still shows its main photo
     instantly without pulling a dozen images over mobile data.
   - Data saver on: nothing is fetched until a swatch is touched.
   Touching a swatch always fetches everything straight away. */
(function(){
  if (window.__fuGangPre) return;
  window.__fuGangPre = true;
  var all = false, firsts = false;
  function eager(i){ if (i && i.getAttribute('loading') === 'lazy') i.setAttribute('loading', 'eager'); }
  function goAll(){
    if (all) return;
    all = true;
    document.querySelectorAll('[data-gang-option] img[loading=lazy]').forEach(eager);
  }
  function goFirsts(){
    if (all || firsts) return;
    firsts = true;
    var seen = {};
    document.querySelectorAll('.product__media-list [data-gang-option][hidden]').forEach(function(m){
      var k = m.getAttribute('data-gang-connect') || '';
      if (seen[k]) return;
      seen[k] = true;
      eager(m.querySelector('img'));
    });
  }
  function idle(){
    var c = navigator.connection || {};
    if (c.saveData) return;
    var small = window.matchMedia('(max-width: 749px)').matches;
    var slow = c.effectiveType && c.effectiveType !== '4g';
    if (small || slow) goFirsts(); else goAll();
  }
  function schedule(){
    var later = function(){ setTimeout(idle, 1500); };
    if ('requestIdleCallback' in window) requestIdleCallback(later, { timeout: 4000 }); else later();
  }
  if (document.readyState === 'complete') schedule(); else window.addEventListener('load', schedule);
  document.addEventListener('pointerdown', function(e){
    var t = e.target;
    if (t && t.closest && t.closest('variant-picker, variant-radios, variant-selects, .variant-picker, [class*=swatch], fieldset, .product-form__input')) goAll();
  }, { passive: true, capture: true });
})();
